module.exports = __webpack_public_path__ + "static/media/16UNODC7.4f1cef98.jpg";